import { render } from "./FeaturesSection.vue?vue&type=template&id=ece0214a"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__